import { Button, Notification } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { useShowEGiftCardRequireNotification } from '@hero/hooks';

import * as S from './style';

function HeaderNotificationContent({ iseGiftCardApprovalBoxShown, recognitionCode }) {
  const { t } = useTranslation();
  const { showEGiftCardNotification } = useShowEGiftCardRequireNotification();

  return (
    <>
      {iseGiftCardApprovalBoxShown && (
        <Notification
          status="warning"
          style={{ marginBottom: 16 }}
          message={
            <S.BannerBadgeWrapper>
              <Trans i18nKey="eGiftCardRequiredApprovalWarning" components={{ b: <b /> }} />
              <Button
                variant="link"
                color="neutral"
                onClick={() => showEGiftCardNotification({ recognitionCode })}
              >
                {t('whatDoesThisMean')}
              </Button>
            </S.BannerBadgeWrapper>
          }
        />
      )}
    </>
  );
}

HeaderNotificationContent.propTypes = {
  iseGiftCardApprovalBoxShown: PropTypes.bool,
  recognitionCode: PropTypes.string
};

export default HeaderNotificationContent;
